import { render, staticRenderFns } from "./InstitutionalQnrSectionView.vue?vue&type=template&id=8b7c6a60&scoped=true&"
import script from "./InstitutionalQnrSectionView.vue?vue&type=script&lang=js&"
export * from "./InstitutionalQnrSectionView.vue?vue&type=script&lang=js&"
import style0 from "./InstitutionalQnrSectionView.vue?vue&type=style&index=0&id=8b7c6a60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b7c6a60",
  null
  
)

export default component.exports